export default __webpack_public_path__ + "static/media/262.f57da1ba.jpg";